// extracted by mini-css-extract-plugin
export default {"overlay":"setting_overlay__E5lFz","popup":"setting_popup__GpMVv","logout":"setting_logout__8oU3+","cross":"setting_cross__GEOBf","avatar":"setting_avatar__YNS7x"};